<template>
  <div class="relative" id="searchSelect-container">
    <input
      v-model="formDataLocal.hotspots[hotspotId]['product_id']"
      @input="handleChange"
      @focus="handleActivate"
      @blur="handleDeactivate"
      placeholder="Search Product"
      class="border-0 pr-[70px] px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
    />
    <div
      v-if="activated"
      class="z-10 p-2 rounded bg-white absolute mt-2 shadow w-full"
    >
      <ul v-if="productSkusList.length > 0" class="overflow-auto max-h-[200px]">
        <li
          class="px-2 py-4 text-xs rounded hover:bg-abi-darkBlue hover:text-white cursor-pointer ease-linear transition-all duration-150"
          v-for="(data, index) in productSkusList"
          :key="index"
          @mousedown="handleSelectProductId(data)"
        >
          {{ data.label }}
        </li>
      </ul>
      <div v-else class="flex justify-center items-center my-4">
        <IconBan />
        <p class="ml-2">No Results</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import IconBan from "@/assets/icons/IconBan";

export default {
  name: "SearchAndSelect",
  components: {
    IconBan
  },
  data() {
    return { activated: false };
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    hotspotId: {
      type: Number,
      required: true
    }
  },
  computed: {
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    productSkusList() {
      let list = [];
      this.searchMultiProducts
        .filter((i) => i.region === this.getRegion && i.status === "publish")
        .forEach((product) => {
          list.push({
            id: product.id.split("-")[1],
            label: product.name + " | " + product.sku
          });
        });
      return list;
    },
    ...mapGetters(["searchMultiProducts", "getRegion"])
  },
  methods: {
    handleActivate(e) {
      this.activated = true;
      if (e.target.value) {
        this.$store.dispatch(Actions.AWS_SEARCH_MULTISELECT_PRODUCTS, {
          search: e.target.value,
          region: this.getRegion
        });
      } else {
        this.$store.dispatch(Actions.AWS_SEARCH_MULTISELECT_PRODUCTS, {
          search: "",
          region: this.getRegion
        });
      }
    },
    handleDeactivate() {
      this.activated = false;
    },
    handleSelectProductId(product) {
      this.formDataLocal.hotspots[this.hotspotId]["product_id"] = product.id;
    },
    handleChange(e) {
      this.$store.dispatch(Actions.AWS_SEARCH_MULTISELECT_PRODUCTS, {
        search: e.target.value,
        region: this.getRegion
      });
    }
  }
};
</script>
